<template>
  <div class="page-wechat-login">
    <div class="container">
      <ym-img class="icon"
              :src="require('@/assets/img/default/logo.png')"
              alt="logo"
      />
      <div class="text">
        * 登录后请尽快完善手机号码信息，并关注官方微信服务号:「少商教育」<follow-subscription value="xiyouEDU" />
        以便接收课程提醒
      </div>
      <ym-button class="login-btn"
                 type="primary"
                 size="large"
                 @click="handleLoginWithWeChat"
      >
        微信一键登录
      </ym-button>
      <div class="user-term-tip">
        <span>点击微信一键登录表示您已阅读并同意
          <span class="link"
                @click="handleService"
          >
            《服务协议》
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import { getLoginWeChatUrl } from '@/services/user';
  import { locationHref } from '@/utils';
  import FollowSubscription from '@/components/FollowSubscription';

  export default {
    name: 'RegisterWechat',
    metaInfo: {
      title: '便捷登录入口',
    },
    components: {
      'ym-button': Button,
      FollowSubscription,
    },
    methods: {
      handleService() {
        this.$router.push({ name: 'UserTerm' });
      },
      async handleLoginWithWeChat() {
        const data = await getLoginWeChatUrl({
          redirectToAfterWeChatLoginCallBack: '/register/wechat/result',
        });
        locationHref(data);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-wechat-login {
    background: @color-white;
    height: 100%;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 @size-medium;
  }

  .icon {
    width: 256px;
    height: 84px;
    margin: 2 * @size-medium 0;
  }

  .text {
    font-size: @font-size-base;
    color: @color-black;
  }

  .login-btn {
    margin-top: @size-medium;
    color: @color-white;
    margin-bottom: @size-small;
  }

  .user-term-tip {
    color: @color-text-lighter;
    font-size: @font-size-extra-small;
  }
</style>
